export const RECS_START = 'Recs.Start';
export const RECS_END = 'Recs.End';
export const RECS_VIEW = 'Recs.View';
export const RECS_RATE = 'Recs.Rate';

export const RECS_PROFILE_OPEN = 'Recs.ProfileOpen';
export const RECS_PROFILE_CLOSE = 'Recs.ProfileClose';

export const RECS_SESSION = 'Recs.Session';
export const RECS_SEARCH = 'Recs.Search';

export const MATCH_NEW = 'Match.New';
